class FacturationDTO {
    public FacturationRequestID: string;
    public DateheureParDefault: Date;
    public CreationDate: Date;
    public GroupeDeFacturation: string;
    public SiteID_Medfar_String: string;
    public IsSansRendezVous: boolean;
    public Has500Patient: boolean;
    public EmployeeId: string;
    public BatchId: string;
    public EmployeeLicence: string;
    public EncounterId: string;
    public Commentaire: string;
    public CodeDeCabinet: string;
    public DateFacturation: Date;

    public PatientDTO: FacturationPatientDTO;
    public FacturationCodes: FacturationCodeDTO[];

    public MedfarBillingStatus: string;
    public MedfarBillingLastErrorMessage: string;
    public MedfarBillingLastUpdate: Date;
    public MedfarBillingAmountReceived: string;
    public MedfarBillingCorrectionSummary: string;

    public IsConferenceCall: boolean;
    public TeleconferenceType: FacturationTeleconferenceType;
    public VulnerabilityCode1: number;
    public VulnerabilityCode2: number;
    public VulnerabilityCode3: number;
}

enum FacturationTeleconferenceType {
    None = 0,
    Telephone = 1,
    Videoconference = 2
}

class FacturationPatientDTO {
    public NAM: string;
    public NamExp: Date;
    public Nom: string;
    public Prenom: string;
    public DDN: Date;
    public Sexe: string;
    public Adresse: string;
    public Ville: string;
    public Zip: string;
    public Telephone1: string;
    public Telephone2: string;
    public Courriel: string;
    public NoDossier: string;

    public RamqInfo: FacturationRAMQinfoDTO;

    public FacturationDiagnotics: FacturationDiagnoticDTO[];

    public DateEvenement: Date;
    public TypeEvenement: string;

    public CommentaireDuMedecin: string;
}

class FacturationCodeDTO {
    public DateFacturation: Date;
    public CodeFacturation: string;
    public Mesure1: string;
    public MesureType1: string;
    public Mesure2: string;
    public MesureType2: string;
    public ElementsdeContext: string[];
    public NomMedecinReferant: string;
    public LicenceMedecinReferant: string;

    public NomMedecinComm: string;
    public PrenomMedecinComm: string;
    public LicenceMedecinComm: string;
    public TypeMedecinComm: string;
    public ProvinceMedecinComm: string;

    public ID: string;
    public FacturationRequestID: string;

    public Description: string;
}

class FacturationRAMQinfoDTO {
    public IsGMF: boolean;
    public MDFamilleLicenceNumber: string;
    public DatePriseEffetInscr: Date;
    public DateInscrGMF: Date;
    public Representant: FacturationRepresentantDTO;
    public VulnerabilityCodes: FacturationVulnerabilityCodesDTO[];
    public PosteInscr: string;
}

class FacturationRepresentantDTO {
    public NamResp: string;
    public NomResp: string;
    public TypeResp: string;
}

class FacturationDiagnoticDTO {
    public DiagCim9Code: string;
    public DiagCim9Text: string;
}

class FacturationVulnerabilityCodesDTO {
    public Code: string;
    public CodeDate: Date;
}

class MedfarBillLightPreview {
    public FacturationRequestId: string;
    public BillSummary: string;
    public CreationDate: Date;
    public IsEditable: boolean;
    public BatchId: string;
    public BillDate: Date;
}

export { FacturationCodeDTO, FacturationDiagnoticDTO, FacturationDTO, FacturationPatientDTO, FacturationRAMQinfoDTO, FacturationRepresentantDTO, FacturationTeleconferenceType, FacturationVulnerabilityCodesDTO, MedfarBillLightPreview };
